import { z } from 'zod';

/** PUT /api/admin/billing/users/:userId/status */
export const AdminUserStatusUpdateSchema = z.object({
  active: z.boolean(),
});
export type AdminUserStatusUpdate = z.infer<typeof AdminUserStatusUpdateSchema>;

export const AdminUserStatusUpdateResponseSchema = z.object({
  message: z.string(),
  active: z.boolean(),
});
export type AdminUserStatusUpdateResponse = z.infer<typeof AdminUserStatusUpdateResponseSchema>;

/** PUT /api/admin/billing/users/:userId/limits */
export const AdminUserLimitsUpdateSchema = z
  .object({
    aiCallsPerMonth: z.number().int().optional(),
    tokensPerMonth: z.number().int().optional(),
  })
  .refine((v) => v.aiCallsPerMonth !== undefined || v.tokensPerMonth !== undefined, {
    message: 'Provide aiCallsPerMonth and/or tokensPerMonth',
  });
export type AdminUserLimitsUpdate = z.infer<typeof AdminUserLimitsUpdateSchema>;

/** GET /api/admin/billing/users/:userId/usage-detail */
export const AdminUserUsageDetailSchema = z.object({
  period: z.string(),
  days: z.number().int(),
  user: z.object({
    id: z.string(),
    name: z.string().nullable(),
    email: z.string(),
    plan: z.string(),
  }),
  usage: z.object({
    aiCalls: z.number().int(),
    inputTokens: z.number().int(),
    outputTokens: z.number().int(),
    totalTokens: z.number().int(),
  }),
  limits: z.object({
    aiCallsPerMonth: z.number().int(),
    tokensPerMonth: z.number().int(),
  }),
  quota: z.object({
    callsOverLimit: z.boolean(),
    tokensOverLimit: z.boolean(),
    callsRemaining: z.number().int(),
    tokensRemaining: z.number().int(),
  }),
  daily: z.array(
    z.object({
      date: z.string(),
      calls: z.number().int(),
      tokens: z.number().int(),
    }),
  ),
  byFeature: z.array(
    z.object({
      feature: z.string(),
      calls: z.number().int(),
      /** null when every token count in the bucket is unknown. */
      tokens: z.number().int().nullable(),
      /** null when every cost in the bucket is unknown. */
      costMicrosUsd: z.number().int().nullable(),
      hasUnknownCost: z.boolean(),
    }),
  ),
  byProviderModel: z.array(
    z.object({
      provider: z.string(),
      model: z.string(),
      calls: z.number().int(),
      tokens: z.number().int().nullable(),
    }),
  ),
  recentCalls: z.array(
    z.object({
      id: z.string(),
      feature: z.string(),
      provider: z.string(),
      model: z.string(),
      inputTokens: z.number().int().nullable(),
      outputTokens: z.number().int().nullable(),
      costMicrosUsd: z.number().int().nullable(),
      latencyMs: z.number().int(),
      status: z.string(),
      createdAt: z.union([z.string(), z.date()]),
    }),
  ),
});
export type AdminUserUsageDetail = z.infer<typeof AdminUserUsageDetailSchema>;
